var map = {
	"./jiaocheng1.bak.png": 8982,
	"./jiaocheng1.png": 963,
	"./jiaocheng2.png": 5644,
	"./jiaocheng3.png": 1634,
	"./jiaocheng4.png": 5827,
	"./jiaocheng5.png": 430,
	"./jiaocheng6.png": 1208,
	"./jiaocheng7.png": 5631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9937;